import React from 'react';
import { useTranslate } from './TranslationText';
import { OperatingSystems } from './Layout';
import './CustomCss/header.css';

const appleStoreLink = process.env.REACT_APP_APPLE_LINK;
const playStoreLink = process.env.REACT_APP_PLAY_LINK;
const baseURL = process.env.REACT_APP_BASE_URL2;

const AppBanner = ({ agentOS }) => {
    const { translate } = useTranslate();

    if (agentOS !== OperatingSystems.IOS && agentOS !== OperatingSystems.ANDROID) {
        return null;
    }

    // On iOS Safari, hide the custom banner — Safari has its own native smart app banner.
    // Other iOS browsers (Chrome, Firefox, etc.) don't have a native banner, so we still show ours.
    if (agentOS === OperatingSystems.IOS) {
        const ua = navigator.userAgent;
        const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
        if (isSafari) {
            return null;
        }
    }

    const storeLink = agentOS === OperatingSystems.ANDROID ? playStoreLink : appleStoreLink;
    
    // Android: intent:// deep link with Play Store fallback built-in
    const androidDeepLink = `intent://success#Intent;scheme=myappscheme;package=com.eahs.main;S.browser_fallback_url=${encodeURIComponent(storeLink)};end;`;

    // iOS: try custom URL scheme first, fall back to App Store after timeout
    const handleiOSOpen = (e) => {
        e.preventDefault();
        const now = Date.now();
        // Try to open the app via custom URL scheme
        window.location.href = 'myappscheme://success';
        // If the app is installed, the browser will leave this page.
        // If not, after 1.5s we redirect to the App Store.
        setTimeout(() => {
            // Only redirect if we're still on the same page (app didn't open)
            if (Date.now() - now < 2000) {
                window.location.href = appleStoreLink;
            }
        }, 1500);
    };

    return (
        <div className="smart-app-banner">
            <div className="banner-content container">
                <div className="d-flex align-items-center w-100">
                    <div className="app-icon-container mx-2">
                        <img src={`${baseURL}/assets/img/squarlogo.png`} alt="App Icon" className="app-icon" />
                    </div>
                    
                    <div className="app-info flex-grow-1">
                        <h6 className="app-title mb-0">
                            {translate('web.appTitle', 'EAHS - Open EAHS app')}
                        </h6>
                        {/* <p className="app-subtitle mb-0 text-muted">
                            {translate('web.appSubtitle', 'Open in the EAHS app')}
                        </p> */}
                    </div>
                    
                    {agentOS === OperatingSystems.IOS ? (
                        <button onClick={handleiOSOpen} className="btn btn-primary open-app-btn rounded-pill px-3">
                            {translate('web.open', 'OPEN')}
                        </button>
                    ) : (
                        <a href={androidDeepLink} target="_top" rel="noopener noreferrer" className="btn btn-primary open-app-btn rounded-pill px-3">
                            {translate('web.open', 'OPEN')}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppBanner;
